export enum ECreditCardType {
  AMERICAN_EXPRESS = 'american express',
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  OTHER = 'other',
}
